import React from "react";

interface ComingSoonActionProps {
  children: React.ReactNode;
  title?: string;
  showBadge?: boolean;
  className?: string;
}

/**
 * Wraps controls that have no backend yet — visually disabled with tooltip.
 */
const ComingSoonAction: React.FC<ComingSoonActionProps> = ({
  children,
  title = "Coming soon",
  showBadge = false,
  className = "",
}) => (
  <span
    className={`coming-soon-control coming-soon-clickable ${className}`.trim()}
    title={title}
    aria-disabled="true"
    onClick={(e) => e.preventDefault()}
    onKeyDown={(e) => e.preventDefault()}
    role="presentation"
  >
    {children}
    {showBadge && <span className="coming-soon-badge">Soon</span>}
  </span>
);

export default ComingSoonAction;
